import { EstablecimientoTempEntry } from "./../../../../../../../shared/entrys/EstablecimientoTemp.entry";
import { RNTPrestadorEntry } from "./../../../../../../../shared/entrys/rnt-prestador.entry";
import { BasicasLoVService } from "src/app/shared/services/basicas-lov.service";
import { MunicipioEntry } from "./../../../../../../../shared/entrys/municipio.entry";
import { DepartamentoEntry } from "./../../../../../../../shared/entrys/departamento.entry";
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  AfterContentInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";
import { Subscription } from "rxjs";
import { CategoriaEntry } from "src/app/shared/entrys/categoria.entry";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SubCategoriaEntry } from "src/app/shared/entrys/sub-categoria.entry";
import { EstablecimientoComercioService } from "../../establecimiento-comercio/establecimiento-comercio.service";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { PrestadorEntry } from "src/app/shared/entrys/prestador.entry";
import { InformarcionTempEntry } from "src/app/shared/entrys/InformarcionTemp.entry";
import { RNTOtrasSolicitudEntry } from "src/app/shared/entrys/RNTOtrasSolicitudEntry.entry";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CompletaInformacionService } from "../completa-informacion/completa-informacion.service";
import { EstadosSolicitud } from "src/app/shared/enumeraciones/estados-solicitud.enum";
import { RatificaInformacionEntry } from "src/app/shared/entrys/ratificacion-informacion.entry";
import { AyudasService } from "src/app/components/contenido/containers/ayudas/ayudas.service";
import { TipoPrestador } from "src/app/shared/enumeraciones/tipo-prestador.enum";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
// tslint:disable-next-line:max-line-length
import {
  ConfirmarRespuestaModel,
  TipoConfirmacionModalType,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { TipoSolicitud } from "src/app/shared/enumeraciones/tipo-solicitud.enum";
import { ModalAceptarTerminosComponent } from "src/app/components/core/layouts/modal-aceptar-terminos/modal-aceptar-terminos.component";
import { UsuarioProvisionalModel } from "src/app/shared/models/usuario-provisional.model";
import { ActividadEconomicaEntry } from "src/app/shared/entrys/actividad-economica.entry";
import { ModalActividadEconomicaComponent } from "src/app/components/seguridad/layouts/modal-actividad-economica/modal-actividad-economica.component";
import { BaseServiceService } from "src/app/shared/services/base-service.service";
import { TipoPrestadorId } from "src/app/shared/enumeraciones/tipo-prestador-id.enum";
import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable";
import { CompletaInformacionServicePlataformas } from './completa-informacion-plataformas.service';
import { CapacidadTecnicaService } from '../capacidad/capacidad-tecnica.service';
import { TipoCapacidad } from 'src/app/shared/enumeraciones/tipo-capacidad.enum';
import { PlataformasElectronicasDigitalesFlow } from "src/app/shared/flows/plataformas-electronicas-digitales.flow";
import { IndicesPasosPlataformasDigitales } from "src/app/shared/enumeraciones/indices-pasos-plataformas-digitales.enum";
import { CapacidadOperativaService } from "../capacidad/capacidad-operativa.service";
import { CapacidadTecnicaEntry } from "src/app/shared/entrys/capacidad-tecnica.entry";
import { CapacidadOperativaEntry } from "src/app/shared/entrys/capacidad-operativa.entry";
import { ModalCambioInmuebleComponent } from "src/app/components/core/layouts/modal-cambio-inmueble/modal-cambio-inmueble.component";
import { DetalleEstablecimientoService } from "../../../funcionario/opciones/establecimiento/establecimiento.service";
import { ModalValidarRenovacionComponent } from "src/app/components/core/layouts/modal-validar-renovacion/modal-validar-renovacion.component";
import { ModalValidarSubcategoriaComponent } from "src/app/components/core/layouts/modal-validar-subcategoria/modal-validar-subcategoria.component";
import { SubcategoriaService } from '../../../administrador/configuracion/subcategoria/subcategoria.service';
import { EstadosRnt } from "src/app/shared/enumeraciones/estados-rnt.enum";
import { CategoriaService } from '../../../administrador/configuracion/categoria/categoria.service';
import { ModalNuevaCategoriaComponent } from "src/app/components/core/layouts/modal-nueva-categoria/modal-nueva-categoria.component";

@Component({
  selector: "app-completa-informacion-plataformas",
  templateUrl: "./completa-informacion-plataformas.component.html",
  styleUrls: ["./completa-informacion-plataformas.component.scss"],
})
// tslint:disable-next-line:component-class-suffix
export class CompletaInformacionPlataformas implements OnInit, OnDestroy {
  @Output()
  pasoActual: EventEmitter<any> = new EventEmitter();
  hasRequiredActions: boolean = false;
  otraSolicitud: RNTOtrasSolicitudEntry;
  establecimientoTemp: EstablecimientoEntry;
  tipo_solicitud_actualizacion = TipoSolicitud.Actualizacion;
  tipo_renovacion = TipoSolicitud.Renovacion;
  estado_devuelto = EstadosSolicitud.Devuelto;
  tipo_solicitud_nueva = TipoSolicitud.Inscripcion;
  tipo_reactivacion = TipoSolicitud.Reactivacion;
  suspendido_por_no_renovar: EstadosRnt.SuspendidoPorNoRenovar;
  subscription: Subscription;
  establecimiento: EstablecimientoEntry;
  prestador: PrestadorEntry;
  rnt: RNTPrestadorEntry;
  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  categorias: Array<CategoriaEntry>;
  subCategorias: Array<SubCategoriaEntry>;
  completaForm: FormGroup;
  completaFormTemp: FormGroup;
  boton: string;
  ratificaInformacion: RatificaInformacionEntry;
  departamentos: Array<DepartamentoEntry>;
  municipios: Array<MunicipioEntry>;
  municipios_notificaciones: Array<MunicipioEntry>;
  informacionTemp: InformarcionTempEntry;
  texto_aceptacion_terminos: string = "";
  informacionUsuarioDepositario: UsuarioProvisionalModel;
  nombrePrestador: string;
  noComercianteId: number = TipoPrestadorId.NoComerciante;
  responseConfigCapacidadesTecnicas: any;
  responseConfigCapacidadesOperativas: any;
  tieneCapacidades: boolean;
  capacidadesOperativas = [];
  capacidadesTecnicas = [];
  establecimientoDetalle: any;
  mostrarCapacidadTecnica: boolean = false;
  mostrarCapacidadOperativa: boolean = false;
  constructor(
    private basicasLoVService: BasicasLoVService,
    private router: Router,
    private dataSharedService: DataSharedService,
    private completaInformacionServicePlataformas: CompletaInformacionServicePlataformas,
    private formBuilder: FormBuilder,
    private establecimientoComercioService: EstablecimientoComercioService,
    private authService: AuthService,
    private modalService: NgbModal,
    private completaInformacionService: CompletaInformacionService,
    private baseService: BaseServiceService,
    public ayudaService: AyudasService,
    private capacidadTecnicaService: CapacidadTecnicaService,
    private capacidadOperativaService: CapacidadOperativaService,
    private detalleEstablecimientoService: DetalleEstablecimientoService,
    private subCategoriaService: SubcategoriaService,
    private categoriaService : CategoriaService
  ) {
    this.prestador = {} as PrestadorEntry;
    this.rnt = {} as RNTPrestadorEntry;
    this.establecimiento = {} as EstablecimientoEntry;
    this.completaForm = formBuilder.group({
      // categoria
      categoria_id: ["", Validators.required],
      sub_categoria_id: ["", Validators.required],
      // contacto
      nombre_representante_legal: [""],
      numero_telefonico: [""],
      numero_celular: [""],
      correo_electronico: [""],
      fax: [""],
      // informacion plataformas
      direccion_comercial: [""],
      codigo_departamento: [""],
      municipio_id: ["", Validators.required],
      // Notificaciones
      municipio_notificacion_id: [Validators.required],
      codigo_departamento_notificacion: ["", Validators.required],
      numero_telefonico_notificacion: ["", [Validators.required]],
      direccion_notificacion: ["", Validators.required],
    });
    this.subscription = this.dataSharedService.data$.subscribe((dataShared) => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
      if (
        (this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
          this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion) ||
        this.datoSolicitudSharedModel.tipo_solicitud ===
          TipoSolicitud.Renovacion ||
        this.datoSolicitudSharedModel.tipo_solicitud ===
          TipoSolicitud.Actualizacion
      ) {
        this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
        this.completaInformacionService
            .getEstablecimientosPendiente(this.rnt)
            .subscribe((resultado) => {
              if (resultado.result) {
                this.establecimientoDetalle = resultado.data as EstablecimientoEntry;
                this.establecimiento = resultado.data as EstablecimientoEntry;
                if(this.establecimientoDetalle.cambio_camara){
                  this.rnt.codigo_camara = this.establecimientoDetalle.codigo_camara;
                  this.rnt.descripcion_camara = this.establecimientoDetalle.desc_camara;
                  this.abrirModalCambioDireccionRNT();
                }
                
                this.formulario();
                this.comprobarTipoPermisoCategoria();
              }
            },error=>{
              this.formulario();
            });
        this.ratificaInformacion = {
          cantidad_modificaciones:
            this.datoSolicitudSharedModel.data.cantidad_modificaciones || 0,
          ratifica_informacion:
            this.datoSolicitudSharedModel.data.ratifica_informacion || false,
        } as RatificaInformacionEntry;
      } else {
        if (
          this.datoSolicitudSharedModel.estado_solicitud ===
          EstadosSolicitud.Devuelto
        ) {
          this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
        } else {
          if (
            this.datoSolicitudSharedModel.data &&
            this.datoSolicitudSharedModel.data.detalle_solicitud_id
          ) {
            this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
          } else {
            this.establecimiento = {} as EstablecimientoEntry;
          }
        }
      }
      this.formulario();
      this.comprobarTipoPermisoCategoria();
    });
  }
  async ngOnInit() {

    //TODO:: Capacidad, revisar mas a fondo.
    this.tieneCapacidades = true;
    if(this.datoSolicitudSharedModel.capacidadesTecnicas === undefined || this.datoSolicitudSharedModel.capacidadesOperativas === undefined){
      this.datoSolicitudSharedModel.capacidadesTecnicas = await this.capacidadTecnicaService.getConfigCapacidades( TipoCapacidad.Tecnica, this.datoSolicitudSharedModel.tipo_rnt).toPromise();
      this.datoSolicitudSharedModel.capacidadesOperativas = await this.capacidadTecnicaService.getConfigCapacidades( TipoCapacidad.Operativa, this.datoSolicitudSharedModel.tipo_rnt).toPromise();
    } 
    if(this.rnt.hasOwnProperty('detalle_solicitud_id') && this.rnt.hasOwnProperty('codigo_camara')){
      this.cargarCapacidades();
    }
    

    if (this.capacidadesTecnicas.length > 0 || this.capacidadesOperativas.length > 0) {
      this.tieneCapacidades = true;
    }

    this.pasoActual.emit(1);
    if((this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion)){
        this.pasoActual.emit(2);
      }

    this.establecimientoComercioService
      .getPrestador({
        usuario: this.authService.getUserNameToken(),
        ...this.datoSolicitudSharedModel.data,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.informacionUsuarioDepositario =
            resultado.data.numero_identificacion_usuario_provisional !== null
              ? {
                  cargo_usuario_provisional:
                    resultado.data.cargo_usuario_provisional,
                  correo_electronico_reportado:
                    resultado.data.correo_electronico_reportado,
                  correo_usuario_provisional:
                    resultado.data.correo_usuario_provisional,
                  nombre_usuario_provisional:
                    resultado.data.nombre_usuario_provisional,
                  apellido_usuario_provisional:
                    resultado.data.apellido_usuario_provisional,
                  numero_identificacion_usuario_provisional:
                    resultado.data.numero_identificacion_usuario_provisional,
                  tipo_identificacion_usuario_provisional:
                    resultado.data.tipo_identificacion_usuario_provisional,
                }
              : null;
          this.prestador = resultado.data as PrestadorEntry;
          this.cargaInicial();
        }
      });

  }

  cargaInicial(){
    if (
      (this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion) ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Renovacion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion
    ) {
      if(this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion ){
        this.pasoActual.emit({ totalPasos: 5 });
      } else if ((this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion)){
          this.pasoActual.emit({ totalPasos: 6 });
      }

      if (
        this.datoSolicitudSharedModel.estado_solicitud ===
        EstadosSolicitud.Devuelto
      ) {
        if (
          this.datoSolicitudSharedModel.data &&
          this.datoSolicitudSharedModel.data.detalle_solicitud_id
        ) {
          this.completaInformacionServicePlataformas
            .getEstablecimientosPendiente(this.rnt)
            .subscribe((resultado) => {
              if (resultado.result) {
                this.establecimiento = resultado.data as EstablecimientoEntry;
                if(this.establecimiento.cambio_camara){
                  this.rnt.codigo_camara = this.establecimiento.codigo_camara;
                  this.rnt.descripcion_camara = this.establecimiento.desc_camara;
                  this.abrirModalCambioDireccionRNT();
                }
                if (
                  this.rnt.aplica_pago_parafiscales &&
                  this.rnt.aplica_pago_parafiscales === true && (
                  this.datoSolicitudSharedModel.tipo_solicitud ===
                    TipoSolicitud.Renovacion ||
                  (this.datoSolicitudSharedModel.data.estado_rnt_id 
                    === EstadosRnt.SuspendidoPorNoRenovar &&  
                  this.datoSolicitudSharedModel.tipo_solicitud 
                    ===TipoSolicitud.Reactivacion)
                  ) &&
                  !this.datoSolicitudSharedModel.data
                    .excepcion_municipio_pago_fontur
                ) {
                  this.pasoActual.emit({ totalPasos: 6 });
                }
                if (
                  this.datoSolicitudSharedModel.tipo_solicitud ===
                  TipoSolicitud.Actualizacion
                ) {
                  this.onSubCategorias();
                }
                this.formulario();
                this.onDepartamento();
                this.onMunicipio();
                this.onMunicipioNotificacion();
              }
            });
        } else {
          this.completaInformacionService
            .createDevolucion(this.rnt)
            .subscribe((resultadoDev) => {
              if (resultadoDev.result) {
                this.rnt = { ...this.rnt, ...resultadoDev.data };
                this.completaInformacionServicePlataformas
                  .getEstablecimientosPendiente(this.rnt)
                  .subscribe((resultado) => {
                    if (resultado.result) {
                      this.establecimiento = resultado.data as EstablecimientoEntry;
                      if(this.establecimiento.cambio_camara){
                        this.rnt.codigo_camara = this.establecimiento.codigo_camara;
                        this.rnt.descripcion_camara = this.establecimiento.desc_camara;
                        this.abrirModalCambioDireccionRNT();
                      }
                      if (
                        this.rnt.aplica_pago_parafiscales &&
                        this.rnt.aplica_pago_parafiscales === true &&
                        (
                          (
                            this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
                            this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion
                          ) ||
                        this.datoSolicitudSharedModel.tipo_solicitud ===
                          TipoSolicitud.Renovacion )
                        &&
                        !this.datoSolicitudSharedModel.data
                          .excepcion_municipio_pago_fontur
                      ) {
                        this.pasoActual.emit({ totalPasos: 6 });
                      }
                      if (
                        this.datoSolicitudSharedModel.tipo_solicitud ===
                        TipoSolicitud.Actualizacion
                      ) {
                        this.onSubCategorias();
                      }
                      this.formulario();
                      this.onDepartamento();
                      this.onMunicipio();
                      this.onMunicipioNotificacion();
                    }
                  });
              } else {
                this.router.navigate(["/mis-establecimientos"]);
              }
            });
        }
      } else {
        if (
          this.datoSolicitudSharedModel.tipo_solicitud ===
          TipoSolicitud.Actualizacion
        ) {
          if (
            this.datoSolicitudSharedModel.data &&
            this.datoSolicitudSharedModel.data.detalle_solicitud_id
          ) {
            this.completaInformacionServicePlataformas
              .getEstablecimientosPendiente(this.rnt)
              .subscribe((res) => {
                if (res.result) {
                  this.establecimiento = res.data as EstablecimientoEntry;
                  if(this.establecimiento.cambio_camara){
                    this.rnt.codigo_camara = this.establecimiento.codigo_camara;
                    this.rnt.descripcion_camara = this.establecimiento.desc_camara;
                    this.abrirModalCambioDireccionRNT();
                  }
                  this.onSubCategorias();
                  this.formulario();
                  this.onDepartamento();
                  this.onMunicipio();
                  this.onMunicipioNotificacion();
                }
              });
          } else {
            this.completaInformacionServicePlataformas
              .createActualizacion(this.rnt)
              .subscribe((resultadoRen) => {
                if (resultadoRen.result) {
                  this.rnt = { ...this.rnt, ...resultadoRen.data };
                  this.completaInformacionServicePlataformas
                    .getEstablecimientosPendiente(this.rnt)
                    .subscribe((res) => {
                      if (res.result) {
                        this.establecimiento = res.data as EstablecimientoEntry;
                        if(this.establecimiento.cambio_camara){
                          this.rnt.codigo_camara = this.establecimiento.codigo_camara;
                          this.rnt.descripcion_camara = this.establecimiento.desc_camara;
                          this.abrirModalCambioDireccionRNT();
                        }
                        this.onSubCategorias();
                        this.formulario();
                        this.onDepartamento();
                        this.onMunicipio();
                        this.onMunicipioNotificacion();
                      }
                    });
                } else {
                  this.router.navigate(["/mis-establecimientos"]);
                }
              });
          }
        } else {
          if (
            this.datoSolicitudSharedModel.data &&
            this.datoSolicitudSharedModel.data.detalle_solicitud_id
          ) {
            this.completaInformacionServicePlataformas
              .getEstablecimientosPendiente(this.rnt)
              .subscribe((resultado) => {
                if (resultado.result) {
                  this.establecimiento = resultado.data as EstablecimientoEntry;
                  if(this.establecimiento.cambio_camara){
                    this.rnt.codigo_camara = this.establecimiento.codigo_camara;
                    this.rnt.descripcion_camara = this.establecimiento.desc_camara;
                    this.abrirModalCambioDireccionRNT();
                  }
                  if (
                    this.rnt.aplica_pago_parafiscales &&
                    this.rnt.aplica_pago_parafiscales === true &&
                    !this.datoSolicitudSharedModel.data
                      .excepcion_municipio_pago_fontur
                  ) {
                    this.pasoActual.emit({ totalPasos: 6 });
                  }
                  this.formulario();
                  this.onDepartamento();
                  this.onMunicipio();
                  this.onMunicipioNotificacion();
                }
              });
          } else {
            this.completaInformacionService
              .createRenovacion(this.rnt)
              .subscribe(
                (resultadoRen) => {
                  if (resultadoRen.result) {
                    this.rnt = { ...this.rnt, ...resultadoRen.data };
                    this.completaInformacionServicePlataformas
                      .getEstablecimientosPendiente(this.rnt)
                      .subscribe((resultado) => {
                        if (resultado.result) {
                          this.establecimiento = resultado.data as EstablecimientoEntry;
                          if(this.establecimiento.cambio_camara){
                            this.rnt.codigo_camara = this.establecimiento.codigo_camara;
                            this.rnt.descripcion_camara = this.establecimiento.desc_camara;
                            this.abrirModalCambioDireccionRNT();
                          }
                          if (
                            this.rnt.aplica_pago_parafiscales &&
                            this.rnt.aplica_pago_parafiscales === true &&
                            !this.datoSolicitudSharedModel.data
                              .excepcion_municipio_pago_fontur
                          ) {
                            this.pasoActual.emit({ totalPasos: 6 });
                          }
                          this.formulario();
                          this.onDepartamento();
                          this.onMunicipio();
                          this.onMunicipioNotificacion();
                        }
                      });
                  } else {
                    this.router.navigate(["/mis-establecimientos"]);
                  }
                },
                (error) => {
                  this.router.navigate(["/mis-establecimientos"]);
                }
              );
          }
        }
      }
    } else {
      if (
        this.datoSolicitudSharedModel.estado_solicitud ===
        EstadosSolicitud.Devuelto
      ) {
        if (
          this.datoSolicitudSharedModel.data &&
          this.datoSolicitudSharedModel.data.detalle_solicitud_id
        ) {
          this.completaInformacionServicePlataformas
            .getEstablecimientosPendiente(this.rnt)
            .subscribe((resultado) => {
              if (resultado.result) {
                this.establecimiento = resultado.data as EstablecimientoEntry;
                this.completaInformacionService
                .get({
                  ...this.establecimiento,
                  rnt_id: this.rnt.rnt_id || this.establecimiento.rnt_id,
                  tipo_rnt_id: this.rnt.tipo_rnt_id || this.establecimiento.tipo_rnt_id,
                  prestador_id: this.prestador.prestador_id
                })
                  .subscribe((resultadoCate) => {
                    if (resultadoCate.result) {
                      this.categorias = resultadoCate.data as Array<CategoriaEntry>;
                    }
                  });
                this.formulario();
                this.onDepartamento();
                // tslint:disable-next-line:radix
                this.basicasLoVService
                  .getMunicipiosxDepartamento(
                    this.establecimiento.codigo_departamento
                  )
                  .subscribe((resultadoMun) => {
                    if (resultadoMun.result) {
                      this.municipios = resultadoMun.data as Array<MunicipioEntry>;
                    }
                  });
                // tslint:disable-next-line:radix
                this.basicasLoVService
                  .getMunicipiosxDepartamento(
                    this.establecimiento.codigo_departamento_notificacion
                  )
                  .subscribe((resultadoMunN) => {
                    if (resultadoMunN.result) {
                      this.municipios_notificaciones = resultadoMunN.data as Array<MunicipioEntry>;
                    }
                  });
              }
            });
        } else {
          this.completaInformacionService
            .createDevolucion(this.rnt)
            .subscribe((resultadoDev) => {
              if (resultadoDev.result) {
                this.rnt = { ...this.rnt, ...resultadoDev.data };
                this.formulario();
                this.completaInformacionServicePlataformas
                  .getEstablecimientosPendiente(this.rnt)
                  .subscribe((resultado) => {
                    if (resultado.result) {
                      this.establecimiento = resultado.data as EstablecimientoEntry;
                      this.formulario();
                      this.onDepartamento();
                      // tslint:disable-next-line:radix
                      this.basicasLoVService
                        .getMunicipiosxDepartamento(
                          this.establecimiento.codigo_departamento
                        )
                        .subscribe((resultadoMun) => {
                          if (resultadoMun.result) {
                            this.municipios = resultadoMun.data as Array<MunicipioEntry>;
                          }
                        });
                      // tslint:disable-next-line:radix
                      this.basicasLoVService
                        .getMunicipiosxDepartamento(
                          this.establecimiento.codigo_departamento_notificacion
                        )
                        .subscribe((resultadoMunN) => {
                          if (resultadoMunN.result) {
                            this.municipios_notificaciones = resultadoMunN.data as Array<MunicipioEntry>;
                          }
                        });
                    }
                  });
              } else {
                this.router.navigate(["/mis-establecimientos"]);
              }
            });
        }
      } else {
        if (
          this.datoSolicitudSharedModel.data &&
          this.datoSolicitudSharedModel.data.detalle_solicitud_id
        ) {
          this.completaInformacionServicePlataformas
            .getEstablecimientosPendiente(this.rnt)
            .subscribe((resultado) => {
              if (resultado.result) {
                this.establecimiento = resultado.data as EstablecimientoEntry;
                this.formulario();
                if (!this.rnt.es_devuelta) {
                  this.onCategorias();
                  this.onSubCategorias();
                  this.completaForm.patchValue({
                    sub_categoria_id: this.rnt.sub_categoria_id,
                  },{emitEvent: false, onlySelf: true});
                }
                this.onDepartamento();
                this.onMunicipio();
                this.onMunicipioNotificacion();
              }
            });
        } else {
          this.completaInformacionServicePlataformas
            .getEstablecimientoInscripcion()
            .subscribe((resultado) => {
              if (resultado.result) {
                this.establecimiento = resultado.data as EstablecimientoEntry;
                this.formulario();
                if (!this.rnt.es_devuelta) {
                  this.onCategorias();
                  this.onSubCategorias();
                  this.completaForm.patchValue({
                    sub_categoria_id: this.rnt.sub_categoria_id,
                  },{emitEvent: false, onlySelf: true});
                }
                this.onDepartamento();
              } else {
                this.router.navigate(["mis-establecimientos"]);
              }
            });
        }
      }
    }
    this.validacionElegirNuevaCategoria();
  }

  cargarCapacidades() {
  
    this.capacidadTecnicaService
    .get(this.rnt)
    .subscribe((resultado) => {
      if (resultado.result) {
        this.capacidadesTecnicas =
        resultado.data as Array<CapacidadTecnicaEntry>;
        if (this.capacidadesTecnicas.length > 0) {
          this.tieneCapacidades = true;
        }
      }
    });

    this.capacidadOperativaService
    .get(this.rnt)
    .subscribe((resultado) => {
      if (resultado.result) {
        this.capacidadesOperativas =
        resultado.data as Array<CapacidadOperativaEntry>;
        if (this.capacidadesOperativas.length > 0) {
          this.tieneCapacidades = true;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  formulario() {
    if (
      (this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion) ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Renovacion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion
    ) {
      this.completaForm = this.formBuilder.group({
        detalle_solicitud_id: [
          this.rnt.detalle_solicitud_id,
          Validators.required,
        ],
        desc_categoria: [
          { value: this.rnt.descripcion_categoria, disabled: true },
          Validators.required,
        ],
        desc_sub_categoria: [
          { value: this.rnt.descripcion_tipo_establecimiento, disabled: true },
          Validators.required,
        ],
        numero_telefonico: [this.establecimiento.numero_telefonico],
        numero_celular: [this.establecimiento.numero_celular],
        correo_electronico: [this.establecimiento.correo_electronico],
        fax: [this.establecimiento.fax],
        codigo_departamento: [
          this.establecimiento.codigo_departamento
        ],
        municipio_id: [this.establecimiento.municipio_id],
        municipio_notificacion_id: [
          this.establecimiento.municipio_notificacion_id,
        ],
        codigo_departamento_notificacion: [
          this.establecimiento.codigo_departamento_notificacion,
        ],
        numero_telefonico_notificacion: [
          this.establecimiento.numero_telefonico_notificacion,
        ],
        nombre_representante_legal: [
          this.establecimiento.nombre_representante_legal,
        ],
        direccion_notificacion: [this.establecimiento.direccion_notificacion],
        direccion_comercial: [
          { value: this.establecimiento.direccion_comercial, disabled: true },
          Validators.required,
        ],
        desc_dpto: [
          { value: this.establecimiento.desc_dpto, disabled: true },
          Validators.required,
        ],
        desc_municipio: [
          { value: this.establecimiento.desc_municipio, disabled: true },
          Validators.required,
        ],
        categoria_id: [this.rnt.categoria_id, Validators.required],
        sub_categoria_id: [this.rnt.sub_categoria_id, Validators.required],
      });
      this.onSubCategorias();
      this.completaForm.patchValue({
          sub_categoria_id: this.rnt.sub_categoria_id,
      },{emitEvent: false, onlySelf: true});
    } else {
      if (
        this.datoSolicitudSharedModel.estado_solicitud ===
          EstadosSolicitud.Devuelto ||
        this.rnt.es_devuelta
      ) {
        this.completaForm = this.formBuilder.group({
          detalle_solicitud_id: [
            this.rnt.detalle_solicitud_id,
            Validators.required,
          ],
          desc_categoria: [
            { value: this.rnt.descripcion_categoria, disabled: true },
            Validators.required,
          ],
          desc_sub_categoria: [
            {
              value: this.rnt.descripcion_tipo_establecimiento,
              disabled: true,
            },
            Validators.required,
          ],
          numero_telefonico: [this.establecimiento.numero_telefonico],
          numero_celular: [this.establecimiento.numero_celular],
          correo_electronico: [this.establecimiento.correo_electronico],
          fax: [this.establecimiento.fax],
          codigo_departamento: [
            this.establecimiento.codigo_departamento
          ],
          municipio_id: [
            this.establecimiento.municipio_id
          ],
          municipio_notificacion_id: [
            this.establecimiento.municipio_notificacion_id,
          ],
          codigo_departamento_notificacion: [
            this.establecimiento.codigo_departamento_notificacion,
          ],
          numero_telefonico_notificacion: [
            this.establecimiento.numero_telefonico_notificacion,
          ],
          nombre_representante_legal: [
            this.establecimiento.nombre_representante_legal,
          ],
          direccion_notificacion: [this.establecimiento.direccion_notificacion],
          direccion_comercial: [
            { value: this.establecimiento.direccion_comercial, disabled: true }
          ],
          desc_dpto: [
            { value: this.establecimiento.desc_dpto, disabled: true },
            Validators.required,
          ],
          desc_municipio: [
            { value: this.establecimiento.desc_municipio, disabled: true },
            Validators.required,
          ],
        });
      } else {
        this.completaForm = this.formBuilder.group({
          categoria_id: [this.rnt.categoria_id, Validators.required],
          sub_categoria_id: [this.rnt.sub_categoria_id, Validators.required],
          numero_telefonico: [this.establecimiento.numero_telefonico],
          numero_celular: [this.establecimiento.numero_celular],
          correo_electronico: [this.establecimiento.correo_electronico],
          fax: [this.establecimiento.fax],
          codigo_departamento: [
            this.rnt.detalle_solicitud_id
              ? this.establecimiento.codigo_departamento
              : ""
          ],
          municipio_id: [
            this.rnt.detalle_solicitud_id
              ? this.establecimiento.municipio_id
              : ""
          ],
          municipio_notificacion_id: [
            this.establecimiento.municipio_notificacion_id,
          ],
          codigo_departamento_notificacion: [
            this.establecimiento.codigo_departamento_notificacion,
          ],
          numero_telefonico_notificacion: [
            this.establecimiento.numero_telefonico_notificacion,
          ],
          nombre_representante_legal: [
            this.establecimiento.nombre_representante_legal,
          ],
          direccion_notificacion: [this.establecimiento.direccion_notificacion],
          direccion_comercial: [
            this.rnt.detalle_solicitud_id
              ? this.establecimiento.direccion_comercial
              : ""
          ],
        });
      }
    }
    // FIXME: Descomentar esta linea para empezar cargue por rues o dian al inmueble
    // this.formularioDisabled();
    this.validarSubCategoria();
  }

  formularioDisabled() {
    if (this.authService.getRolDetalleUser() === TipoPrestador.Comerciante) {
      //#region Datos de contacto
      this.completaForm.get("numero_telefonico").disable();
      this.completaForm.get("numero_celular").disable();
      this.completaForm.get("correo_electronico").disable();
      this.completaForm.get("fax").disable();
      this.completaForm.get("nombre_representante_legal").disable();
      //#endregion
      //#region Datos de notificacion
      this.completaForm.get("codigo_departamento_notificacion").disable();
      this.completaForm.get("numero_telefonico_notificacion").disable();
      this.completaForm.get("direccion_notificacion").disable();
      this.completaForm.get("municipio_notificacion_id").disable();
      //#endregion
    } else {
      //#region Datos de contacto
      this.completaForm.get("numero_telefonico").disable();
      this.completaForm.get("numero_celular").disable();
      this.completaForm.get("correo_electronico").disable();
      this.completaForm.get("fax").disable();
      this.completaForm.get("nombre_representante_legal").disable();
      //#endregion
      //#region Datos de notificacion
      this.completaForm.get("codigo_departamento_notificacion").disable();
      this.completaForm.get("numero_telefonico_notificacion").disable();
      this.completaForm.get("direccion_notificacion").disable();
      this.completaForm.get("municipio_notificacion_id").disable();
      //#endregion
    }
  }

  goPaso() {
    if((this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion)){
        this.rnt.paso = 2;
    }
    this.completaInformacionServicePlataformas
      .getParametro({
        parametro_id: "INDICADOR_MOSTRAR_TRATAMIENTO_DATOS_SOLICITUD",
        agrupacion: "TRATAMIENTO_DATOS",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          if (resultado.data) {
            if(!(this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
              this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion)){
              this.showModalAceptarTermino();
            }else{
              this.validarRenovacionSegunTipoSolicitud();
            }
          } else {
            this.continuarPaso();
          }
        } else {
          this.router.navigate(["/mis-establecimientos"]);
        }
      });
  }

  continuarPaso() {
    if (
      (this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion) ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Renovacion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion 
    ) {
    if (
      this.datoSolicitudSharedModel.tipo_solicitud ===
      TipoSolicitud.Actualizacion
    ) {      
      if (
        this.rnt.sub_categoria_id === this.completaForm.getRawValue().sub_categoria_id
      ) {
        this.completaInformacionServicePlataformas
          .updateEstablecimientoPendiente({
            ...this.prestador,
            ...this.establecimiento,
            ...this.rnt,
            ...this.completaForm.value,
            codigo_camara: this.establecimiento.codigo_camara,
            descripcion_camara: this.establecimiento.desc_camara,
            tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
          })
          .subscribe((resultado) => {
            if (resultado.result) {
              const rnt: RNTPrestadorEntry = {
                ...this.rnt,
                codigo_camara: this.establecimiento.codigo_camara,
                descripcion_camara: this.establecimiento.desc_camara,
                tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
              };
              if (!!this.completaForm && this.completaForm.dirty) {
                this.ratificaInformacion.cantidad_modificaciones += 1;
              }
              this.completaInformacionService
                .update({ ...this.rnt, ...this.ratificaInformacion })
                .subscribe((resultadoDe) => {
                  if (resultadoDe.result) {
                    this.dataSharedService.sharedData(<
                      DatoSolicitudSharedModel
                    >{
                      data: {
                        ...rnt,
                        ratificaInformacion: this.ratificaInformacion,
                        categoria_id: this.completaForm.value.categoria_id,
                        tipo_prestador_id: this.prestador.tipo_prestador_id
                      } as RNTPrestadorEntry,
                      tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
                      tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
                      estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
                    });

                    if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
                      this.tieneCapacidades = true;
                    } else{
                      this.tieneCapacidades = false;
                    }

                    if (this.tieneCapacidades) {
                      PlataformasElectronicasDigitalesFlow.conmutadorDePasosPlataformasDigitales(IndicesPasosPlataformasDigitales.Capacidades, this.router);
                    }else{
                      PlataformasElectronicasDigitalesFlow.conmutadorDePasosPlataformasDigitales(IndicesPasosPlataformasDigitales.TipoDeEstablecimiento, this.router);
                    }

                    }
                  });
              }
            });
        } else {
          const modalRef = this.modalService.open(
            ModalConfirmarRespuestaComponent,
            { centered: true }
          );
          const confirmarRespuesta = {} as ConfirmarRespuestaModel;
          confirmarRespuesta.tipoConfirmacionModalType =
            TipoConfirmacionModalType.Confirmacion;
          confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
          // tslint:disable-next-line:max-line-length
          confirmarRespuesta.message =
            "¿Está seguro de cambiar la categoria del registro? Esta acción eliminará la información registrada hasta el momento.";
          modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
          modalRef.result
            .then((resultadoModal) => {
              this.completaInformacionServicePlataformas
                .updateEstablecimientoPendiente({
                  ...this.prestador,
                  ...this.establecimiento,
                  ...this.rnt,
                  ...this.completaForm.value,
                  codigo_camara: this.establecimiento.codigo_camara,
                  descripcion_camara: this.establecimiento.desc_camara,
                  tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
                })
                .subscribe((resultado) => {
                  if (resultado.result) {
                    const rnt: RNTPrestadorEntry = {
                      ...this.rnt,
                      tipo_solicitud_id: this.datoSolicitudSharedModel
                        .tipo_solicitud,
                    };
                    if (!!this.completaForm && this.completaForm.dirty) {
                      this.ratificaInformacion.cantidad_modificaciones += 1;
                    }
                    this.completaInformacionService
                      .update({ ...this.rnt, ...this.ratificaInformacion })
                      .subscribe((resultadoDe) => {
                        if (resultadoDe.result) {
                          this.completaInformacionService
                            .cambiarCategoria({
                              ...this.rnt,
                              sub_categoria_id: this.completaForm.value
                                .sub_categoria_id,
                            })
                            .subscribe((resultadoC) => {
                              if (resultadoC.result) {
                                this.dataSharedService.sharedData(<
                                  DatoSolicitudSharedModel
                                >{
                                  data: {
                                    ...rnt,
                                    ratificaInformacion: this
                                      .ratificaInformacion,
                                    sub_categoria_id: this.completaForm.value
                                      .sub_categoria_id,
                                    categoria_id: this.completaForm.value.categoria_id,
                                    tipo_prestador_id: this.prestador.tipo_prestador_id
                                  } as RNTPrestadorEntry,
                                  tipo_solicitud: this.datoSolicitudSharedModel
                                    .tipo_solicitud,
                                  tipo_rnt: this.datoSolicitudSharedModel
                                    .tipo_rnt,
                                  estado_solicitud: this
                                    .datoSolicitudSharedModel.estado_solicitud,
                                });
                                if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
                                  this.tieneCapacidades = true;
                                } else{
                                  this.tieneCapacidades = false;
                                }
                                if (this.tieneCapacidades) {
                                  PlataformasElectronicasDigitalesFlow.conmutadorDePasosPlataformasDigitales(IndicesPasosPlataformasDigitales.Capacidades, this.router);
                                }else{
                                  PlataformasElectronicasDigitalesFlow.conmutadorDePasosPlataformasDigitales(IndicesPasosPlataformasDigitales.TipoDeEstablecimiento, this.router);
                                }
                              }
                            });
                        }
                      });
                  }
                });
            })
            .catch(() => {
              this.completaForm.patchValue({
                categoria_id: this.rnt.categoria_id,
                sub_categoria_id: this.rnt.sub_categoria_id,
              },{emitEvent: false, onlySelf: true});
              if (this.rnt.categoria_id) {
                this.completaInformacionServicePlataformas
                  .getSubCategoria({
                    ...this.datoSolicitudSharedModel.data,
                    categoria_id: this.rnt.categoria_id,
                    tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
                    establecimiento_id: "",
                    codigo_camara: "",
                    rnt_id: "",
                    tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
                  })
                  .subscribe((result) => {
                    if (result.result) {
                      this.subCategorias = result.data as Array<SubCategoriaEntry>;
                    }
                  });
              } else {
                this.subCategorias = [];
              }
            });
        }
      } else {
        const rnt: RNTPrestadorEntry = {
          ...this.rnt,
          tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
        };
        if (!!this.completaForm && this.completaForm.dirty) {
          this.ratificaInformacion.cantidad_modificaciones += 1;
        }
        this.completaInformacionService
          .update({ ...this.rnt, ...this.ratificaInformacion })
          .subscribe((resultadoDe) => {
            if (resultadoDe.result) {
              this.completaInformacionServicePlataformas
                .updateEstablecimientoPendiente({
                  ...this.prestador,
                  ...this.establecimiento,
                  ...rnt,
                  ...this.completaForm.value,
                  tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
                  matricula: this.prestador.nit,
                })
                .subscribe((resultado) => {
                  if (resultado.result) {
                    this.dataSharedService.sharedData(<
                      DatoSolicitudSharedModel
                    >{
                      data: {
                        ...rnt,
                        ratificaInformacion: this.ratificaInformacion,
                        nit: this.prestador.nit,
                        categoria_id: this.completaForm.value.categoria_id,
                        tipo_prestador_id: this.prestador.tipo_prestador_id
                      } as RNTPrestadorEntry,
                      tipo_solicitud: this.datoSolicitudSharedModel
                        .tipo_solicitud,
                      tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
                      estado_solicitud: this.datoSolicitudSharedModel
                        .estado_solicitud,
                    });
                    if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
                      this.tieneCapacidades = true;
                    } else{
                      this.tieneCapacidades = false;
                    }
                    if (this.tieneCapacidades) {
                      this.router.navigate(["/solicitud/capacidad"]);
                    }else{
                      this.router.navigate(["/solicitud/tipo-establecimiento"]);
                    }
                  }
                });
            }
          });
      }
    } else {
      if (
        !this.rnt.detalle_solicitud_id ||
        this.establecimiento.municipio_id ===
          this.completaForm.value.municipio_id
      ) {
        this.terminarProceso();
      } else {
        this.completaInformacionServicePlataformas
          .cambioMunicipio({
            codigo_camara: this.rnt.codigo_camara,
            municipio_id: this.completaForm.value.municipio_id,
            rnt_id: this.rnt.rnt_id || this.establecimiento.rnt_id,
          })
          .subscribe((resultado) => {
            if (resultado.result) {
              this.rnt.codigo_camara = resultado.data.codigo_camara;
              this.establecimiento.codigo_camara = resultado.data.codigo_camara;
              this.terminarProceso();
            }
          });
      }
    }
  }

  terminarProceso() {
    if (
      this.datoSolicitudSharedModel.estado_solicitud ===
      EstadosSolicitud.Devuelto
    ) {
      const rnt: RNTPrestadorEntry = {
        ...this.rnt,
        tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
      };
      this.completaInformacionService
        .update({ ...this.rnt, ...this.ratificaInformacion })
        .subscribe((resultadoDe) => {
          if (resultadoDe.result) {
            this.completaInformacionServicePlataformas
              .updateEstablecimientoPendiente({
                ...this.prestador,
                ...this.establecimiento,
                ...rnt,
                ...this.completaForm.value,
                tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
                matricula: this.prestador.nit,
              })
              .subscribe((resultado) => {
                if (resultado.result) {
                  this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                    data: { ...rnt,
                      categoria_id: this.completaForm.value.categoria_id,
                      tipo_prestador_id: this.prestador.tipo_prestador_id } as RNTPrestadorEntry,
                    tipo_solicitud: this.datoSolicitudSharedModel
                      .tipo_solicitud,
                    tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
                    estado_solicitud: this.datoSolicitudSharedModel
                      .estado_solicitud,

                  });
                  if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
                    this.tieneCapacidades = true;
                  } else{
                    this.tieneCapacidades = false;
                  }
                  if (this.tieneCapacidades) {
                    this.router.navigate(["/solicitud/capacidad"]);
                  }else{
                    this.router.navigate(["/solicitud/tipo-establecimiento"]);
                  }
                }
              });
          }
        });
    } else {
      const rnt: RNTPrestadorEntry = {
        ...this.establecimiento,
        ...this.completaForm.value,
        tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
        tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
      };
      if (!this.rnt.sub_categoria_id) {
        this.establecimientoComercioService
          .create({
            ...this.prestador,
            ...this.completaForm.value,
            tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
          })
          .subscribe((res) => {
            if (res.result) {
              this.completaInformacionService
                .create({
                  ...rnt,
                  ...res.data,
                })
                .subscribe((resultado) => {
                  if (resultado.result) {
                    this.dataSharedService.sharedData(<
                      DatoSolicitudSharedModel
                    >{
                      data: {
                        ...rnt,
                        ...resultado.data,
                        ...res.data,
                        categoria_id: this.completaForm.value.categoria_id,
                        tipo_prestador_id: this.prestador.tipo_prestador_id
                      } as RNTPrestadorEntry,
                      tipo_solicitud: this.datoSolicitudSharedModel
                        .tipo_solicitud,
                      tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
                      estado_solicitud: this.datoSolicitudSharedModel
                        .estado_solicitud,
                    });
                    if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
                      this.tieneCapacidades = true;
                    } else{
                      this.tieneCapacidades = false;
                    }
                    if (this.tieneCapacidades) {
                      this.router.navigate(["/solicitud/capacidad"]);
                    }else{
                      this.router.navigate(["/solicitud/tipo-establecimiento"]);
                    }
                  }
                });
            }
          });
      } else {
        if (
          this.rnt.sub_categoria_id === this.completaForm.getRawValue().sub_categoria_id||
          this.rnt.es_devuelta
        ) {
          this.completaInformacionServicePlataformas
            .updateEstablecimientoPendiente({
              ...this.prestador,
              ...this.establecimiento,
              ...this.rnt,
              ...this.completaForm.value,
              tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
              matricula: this.prestador.nit,
            })
            .subscribe((resultado) => {
              if (resultado.result) {
                this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                  data: {
                    ...this.rnt,
                    ...this.completaForm.value,
                    tipo_prestador_id: this.prestador.tipo_prestador_id
                  } as RNTPrestadorEntry,
                  tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
                  tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
                  estado_solicitud: this.datoSolicitudSharedModel
                    .estado_solicitud,
                });
                if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
                  this.tieneCapacidades = true;
                } else{
                  this.tieneCapacidades = false;
                }
                if (this.tieneCapacidades) {
                  this.router.navigate(["/solicitud/capacidad"]);
                }else{
                  this.router.navigate(["/solicitud/tipo-establecimiento"]);
                }
              }
            });
        } else {
          const modalRef = this.modalService.open(
            ModalConfirmarRespuestaComponent,
            { centered: true }
          );
          const confirmarRespuesta = {} as ConfirmarRespuestaModel;
          confirmarRespuesta.tipoConfirmacionModalType =
            TipoConfirmacionModalType.Confirmacion;
          confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
          // tslint:disable-next-line:max-line-length
          confirmarRespuesta.message =
            "¿Está seguro de cambiar la categoria del registro? Esta acción eliminará la información registrada hasta el momento.";
          modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
          modalRef.result
            .then((resultadoModal) => {
              this.completaInformacionServicePlataformas
                .updateEstablecimientoPendiente({
                  ...this.prestador,
                  ...this.rnt,
                  ...this.completaForm.value,
                  tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
                  matricula: this.prestador.nit,
                })
                .subscribe((resultado) => {
                  if (resultado.result) {
                    this.completaInformacionService
                      .revertir(this.rnt)
                      .subscribe((resultadoR) => {
                        if (resultadoR.result) {
                          this.completaInformacionService
                            .create({
                              ...rnt,
                            })
                            .subscribe((res) => {
                              if (res.result) {
                                // sessionStorage.setItem('rnt', JSON.stringify(res.data as RNTPrestadorEntry));
                                this.dataSharedService.sharedData(<
                                  DatoSolicitudSharedModel
                                >{
                                  data: {
                                    ...rnt,
                                    ...res.data,
                                    categoria_id: this.completaForm.value.categoria_id,
                                    tipo_prestador_id: this.prestador.tipo_prestador_id
                                  } as RNTPrestadorEntry,
                                  tipo_solicitud: this.datoSolicitudSharedModel
                                    .tipo_solicitud,
                                  tipo_rnt: this.datoSolicitudSharedModel
                                    .tipo_rnt,
                                  estado_solicitud: this
                                    .datoSolicitudSharedModel.estado_solicitud,
                                });
                                if(this.mostrarCapacidadTecnica || this.mostrarCapacidadOperativa){
                                  this.tieneCapacidades = true;
                                } else{
                                  this.tieneCapacidades = false;
                                }
                                if (this.tieneCapacidades) {
                                  this.router.navigate(["/solicitud/capacidad"]);
                                }else{
                                  this.router.navigate(["/solicitud/tipo-establecimiento"]);
                                }
                              }
                            });
                        }
                      });
                  }
                });
            })
            .catch(() => {
              this.completaForm.patchValue({
                categoria_id: this.rnt.categoria_id,
                sub_categoria_id: this.rnt.sub_categoria_id,
              },{emitEvent: false, onlySelf: true});
              if (this.rnt.categoria_id) {
                this.completaInformacionServicePlataformas
                  .getSubCategoria({
                    ...this.datoSolicitudSharedModel.data,
                    categoria_id: this.rnt.categoria_id,
                    tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
                    establecimiento_id: "",
                    codigo_camara: "",
                    rnt_id: "",
                    tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
                  })
                  .subscribe((result) => {
                    if (result.result) {
                      this.subCategorias = result.data as Array<SubCategoriaEntry>;
                    }
                  });
              } else {
                this.subCategorias = [];
              }
            });
        }
      }
    }
  }

  onCategorias() {
    this.completaInformacionService.get({
        ...this.establecimiento,
        rnt_id: this.rnt.rnt_id || this.establecimiento.rnt_id,
        tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
        prestador_id: this.prestador.prestador_id
      }).subscribe((resultadoCate) => {
      if (resultadoCate.result) {
        this.categorias = resultadoCate.data as Array<CategoriaEntry>;
      }
    });
    if (this.completaForm.value.categoria_id) {
      // Obtenemos la configuracion de las capacidades
      this.getConfiguracionCapacidadTecnica();
      this.getConfiguracionCapacidadOperativa();
    }
  }
  //FIXME
  //PONER NOMBRES DICIENTES Y RELACIONADOS A LOS EVENTOS UBICADOS EN EL ARCHIVO.HTML
  onSubCategorias() {
    localStorage.setItem('idCategoria', this.completaForm.value.categoria_id);

    this.completaForm.patchValue({
      categoria_id: this.completaForm.value.categoria_id,
      sub_categoria_id: null,
    },{emitEvent: false, onlySelf: true});

    if (this.completaForm.value.categoria_id) {
      this.completaInformacionServicePlataformas
        .getSubCategoria({
          ...this.datoSolicitudSharedModel.data,
          categoria_id: this.completaForm.value.categoria_id,
          tipo_rnt_id: this.datoSolicitudSharedModel.tipo_rnt,
          establecimiento_id: "",
          codigo_camara: "",
          rnt_id: "",
          tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.subCategorias = resultado.data as Array<SubCategoriaEntry>;
          }
        });
    } else {
      this.subCategorias = [];
    }
  }
  onSubCategoria(): void{
    this.validarSubCategoria();
  }
  validarSubCategoria():void{
    if(this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Inscripcion ||
      this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion ||
      this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion ||
      (this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion)){
       this.validarSubCategoriaCIIU();
     }
  }
  validarSubCategoriaCIIU():void{
    let prestador_id: number =this.prestador.prestador_id;
    let sub_categoria_id: number =this.completaForm.getRawValue().sub_categoria_id ?? this.rnt.sub_categoria_id;
    let tipo_rnt_id : number = this.rnt.tipo_rnt_id;
    if(prestador_id != null && sub_categoria_id != null && tipo_rnt_id != null){
         this.subscription.add( this.subCategoriaService
          .validarActividadesEconomicasCiiu(prestador_id,sub_categoria_id,tipo_rnt_id)
          .subscribe(response =>{
              if(!response.data){
                this.completaInformacionService
                    .getParametro({
                      parametro_id: "ADVERTENCIA_ACTIVIDAD_ECONOMICA_NO_CORRESPONDE_SUBCATEGORIA_PRESTADOR",
                      agrupacion: "VALIDACIONES",
                      auxiliar: "1",
                    })
                    .subscribe((resultado2) => {
                      if (resultado2.result) {
                        const modalAceptarTerminos = this.modalService.open(
                          ModalValidarSubcategoriaComponent,
                          { centered: true, backdrop: "static", size: "md" }
                        );
                        modalAceptarTerminos.componentInstance.mensaje =resultado2.data;

                      }
                    });
              }
          }));
    }
  }
  onDepartamento() {
    this.basicasLoVService.getDepartamentos(null).subscribe((resultadoD) => {
      if (resultadoD.result) {
        this.departamentos = resultadoD.data as Array<DepartamentoEntry>;
      }
    });
  }
  onMunicipio() {
    this.basicasLoVService
      .getMunicipiosxDepartamento(this.completaForm.value.codigo_departamento)
      .subscribe((resultado) => {
        if (resultado.result) {
          this.municipios = resultado.data as Array<MunicipioEntry>;
        }
      });
  }

  onMunicipioNotificacion() {
    this.basicasLoVService
      .getMunicipiosxDepartamento(
        this.completaForm.value.codigo_departamento_notificacion
      )
      .subscribe((resultado) => {
        if (resultado.result) {
          this.municipios_notificaciones = resultado.data as Array<MunicipioEntry>;
        }
      });
  }

  onLogoCamaraMunicipio() {
    this.pasoActual.emit({
      municipio_id: this.completaForm.value.municipio_id,
    });
  }
  validarRenovacionSegunTipoSolicitud():void{
    if(this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Inscripcion ||
      this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion ||
      this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion ||
      (this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===TipoSolicitud.Reactivacion)){
        this.validarRenovacion();
     }else{
        this.continuarPaso();
     }
  }
  validarRenovacion():void{
    let prestador_id :number= this.prestador.prestador_id;
    let establecimiento_id:number= this.establecimiento.establecimiento_id;

    if(prestador_id != null){
          this.detalleEstablecimientoService
          .validarRenovacion(establecimiento_id,prestador_id)
          .subscribe(response =>{
            if (!response.result) {
              //SI EL ESTABLECIMIENTO ESTA VENCIDO
              if( Number(response.control.code) === 1){
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_PRESTADOR_DEBE_ACTUALIZAR_DATOS_RUES_ESTABLECIMIENTO'
                },true);
              }
              //SI EL PRESTADOR ESTA VENCIDO
              if( Number(response.control.code) === 2){
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_PRESTADOR_DEBE_ACTUALIZAR_DATOS_RUES_PRESTADOR'
                },true);
              }
              //SI EL PRESTADOR Y ESTABLECIMIENTO ESTAN VENCIDOS
              if( Number(response.control.code) === 3){
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_PRESTADOR_DEBE_ACTUALIZAR_DATOS_RUES_PRESTADOR'
                },false);
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_PRESTADOR_DEBE_ACTUALIZAR_DATOS_RUES_ESTABLECIMIENTO'
                },true);
              }
            } else {
              this.continuarPaso();
            }
          },error=>{
            this.continuarPaso();
          });
    }
  }
  getParam({parametro_id,agrupacion,auxiliar},hasAction: boolean): void{
    this.establecimientoComercioService
        .getParametro({
          parametro_id,
          agrupacion,
          auxiliar,
        })
          .subscribe(
            (resultado2) => {
              if (resultado2.result) {
                const modalAceptarRenovacion = this.modalService.open(
                  ModalValidarRenovacionComponent,
                  { centered: true, backdrop: "static", size: "md" }
                );
                modalAceptarRenovacion.componentInstance.mensaje =
                  resultado2.data;
              }
              if(hasAction){
                this.continuarPaso();
              }
            },
            (error) => {
              if(hasAction){
                this.continuarPaso();
              }
            }
          );
  }
  showModalAceptarTermino() {
    this.completaInformacionService
      .getParametro({
        parametro_id: "TEXTO_TRATAMIENTO_DATOS_PASO_SOLICITUD",
        agrupacion: "TRATAMIENTO_DATOS",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.texto_aceptacion_terminos = resultado.data;
          this.completaInformacionService
            .getParametro({
              parametro_id: "TITULO_MODAL_TRATAMIENTO_DATOS_SOLICITUD",
              agrupacion: "TRATAMIENTO_DATOS",
              auxiliar: "1",
            })
            .subscribe((resultado2) => {
              if (resultado2.result) {
                const modalAceptarTerminos = this.modalService.open(
                  ModalAceptarTerminosComponent,
                  { centered: true, backdrop: "static", size: "lg" }
                );
                modalAceptarTerminos.componentInstance.mensaje = this.texto_aceptacion_terminos;
                modalAceptarTerminos.componentInstance.titulo = resultado2.data;
                modalAceptarTerminos.result.then(() => {
                  this.validarRenovacionSegunTipoSolicitud();
                });
              }
            });
        }
      });
  }

  reset_LocalStorage(){
    localStorage.removeItem("keyCategoria");
  }

  verActividades(tipo: string){
    if(tipo === 'prestador'){
      this.nombrePrestador = this.authService.getUserNameToken();

      this.baseService.getActividadesEconomicasPrestador(this.nombrePrestador).subscribe((response) => {
        if (response.control.code == 200) {
          const actividadesEconomicas =
            response.data as Array<ActividadEconomicaEntry>;
          const modalRef = this.modalService.open(
            ModalActividadEconomicaComponent,
            {
              centered: true,
              size: "lg",
              backdropClass: "light-blue-backdrop",
            }
          );
          modalRef.componentInstance.actividadesEconomicas =
            actividadesEconomicas;
          modalRef.componentInstance.tipoUsuario =
            this.authService.getTipoUser();
        }
      });
    }
  }
  comprobarTipoPermisoCategoria(): void{
    this.completaInformacionService
        .getCategoriaPermissionsById(Number(this.rnt.categoria_id))
        .subscribe(response=>{
            if(response.codigoRespuesta == 0){
              if(this.establecimientoDetalle == null){
                this.establecimientoDetalle={tipo_permiso_categoria:response.data[0].tipo_permiso};
              }
            }
            this.deshabilitaSubcategoria();
        },error=>{
          this.deshabilitaSubcategoria();
        });
  }
  deshabilitaSubcategoria(){
    if (this.datoSolicitudSharedModel.tipo_solicitud == 7 ) {
      switch(this.establecimientoDetalle?.tipo_permiso_categoria) {
        case "0": {

           this.completaForm.controls.sub_categoria_id.disable();
           break;
        }
        case"1": {

           this.completaForm.controls.sub_categoria_id.enable();
           break;
        }
        case"2": {

          this.completaForm.controls.sub_categoria_id.disable();
          break;
        }
       case"3": {
        this.completaForm.controls.sub_categoria_id.enable();
        break;
        }
        default: {

           break;
        }
     }
    }

    if (this.datoSolicitudSharedModel.tipo_solicitud == 2 || 
      this.datoSolicitudSharedModel.tipo_solicitud == 5) {
      switch(this.establecimientoDetalle?.tipo_permiso_categoria) {
        case "0": {

           this.completaForm.controls.sub_categoria_id.disable();
           break;
        }
        case"1": {

           this.completaForm.controls.sub_categoria_id.disable();
           break;
        }
        case"2": {

          this.completaForm.controls.sub_categoria_id.enable();
          break;
        }
       case"3": {
        this.completaForm.controls.sub_categoria_id.enable();
        break;
        }
        default: {

           break;
        }
     }
    }
  }

  abrirModalCambioDireccionRNT() {
    const modalRef = this.modalService.open(ModalCambioInmuebleComponent, {
      centered: true,
    });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;
    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    confirmarRespuesta.tipoConfirmacionModalType = TipoConfirmacionModalType.Alerta;
    // tslint:disable-next-line:max-line-length
    confirmarRespuesta.message =
      'Detectamos un cambio en el domicilio';
    confirmarRespuesta.buttonTextAlert = "Continuar";
    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
  }
  getConfiguracionCapacidadTecnica(){
    let idCapacidadTecnica = TipoCapacidad.Tecnica;
    let isComerciante = this.authService.getRolDetalleUser() === TipoPrestador.Comerciante ? true : false;

    this.capacidadTecnicaService.getConfigCapacidades(idCapacidadTecnica, Number(this.rnt.categoria_id)  ?? this.completaForm.value.categoria_id)
    .subscribe((response) => {
      if(response.result){
        if(response.data[0]){
          if(isComerciante){
            this.mostrarCapacidadTecnica = response.data[0].Se_Muestra_Comerciante;
          } else {
            this.mostrarCapacidadTecnica = response.data[0].Se_Muestra_No_Comerciante;
          }
        } else{
          console.log('___WARNING, NO DATA FOUND');
        }
      } else{
        console.log('___ERROR, WEB SERVICE');
      }
    });
  }
  getConfiguracionCapacidadOperativa(){
    let idCapacidadOperativa = TipoCapacidad.Operativa;
    let isComerciante = this.authService.getRolDetalleUser() === TipoPrestador.Comerciante ? true : false;

    this.capacidadTecnicaService.getConfigCapacidades(idCapacidadOperativa, Number(this.rnt.categoria_id)  ?? this.completaForm.value.categoria_id)
    .subscribe((response) => {
      if(response.result){
        if(response.data[0]){
          if(isComerciante){
            this.mostrarCapacidadOperativa = response.data[0].Se_Muestra_Comerciante;
          } else {
            this.mostrarCapacidadOperativa = response.data[0].Se_Muestra_No_Comerciante;
          }
        } else{
          console.log('___WARNING, NO DATA FOUND');
        }
      } else{
        console.log('___ERROR, WEB SERVICE');
      }
    });
  }
  onRegresarPaso(): void{
    if((
      this.datoSolicitudSharedModel.data.estado_rnt_id ===
      EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud ===
      TipoSolicitud.Reactivacion
    )){
      this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
        data: {
          ...this.rnt,
          ...this.datoSolicitudSharedModel.data,
          ratificaInformacion: this.ratificaInformacion,
          nit: this.datoSolicitudSharedModel.data.nit,
          es_devuelta: true,
        } as RNTPrestadorEntry,
        tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
        tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
        estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
      });
      this.router.navigate(["otra-solicitudes"]);
    }
  }
  private validacionElegirNuevaCategoria(): any {
    this.categoriaService
      .getByIdUser(this.rnt.categoria_id)
      .subscribe((x: any) => {
        const categoria = x.data[0];
        let esObligatorioActualizacion = categoria.obligatorio_actualizacion;
        let esObligatorioRenovacion = categoria.obligatorio_renovacion;
        let permiteCambio = categoria.permite_cambio_categoria;
        if( this.datoSolicitudSharedModel.tipo_solicitud == TipoSolicitud.Actualizacion && permiteCambio){
          this.openModalCambioDeCategoriaObligatoria(categoria,esObligatorioActualizacion);
        }
        if((this.datoSolicitudSharedModel.tipo_solicitud == TipoSolicitud.Renovacion ||
            this.datoSolicitudSharedModel.tipo_solicitud == TipoSolicitud.Reactivacion) && permiteCambio){
          this.openModalCambioDeCategoriaObligatoria(categoria,esObligatorioRenovacion);
        }
      });
  }
  
  private openModalCambioDeCategoriaObligatoria(categoria: any,esObligatorio : boolean): void{
    if (
      categoria.permite_cambio_categoria &&
      categoria.fecha_fin_cambio_categoria &&
      categoria.fecha_inicio_cambio_categoria
    ) {
      const today = new Date();
      const fechaFin = new Date(categoria.fecha_fin_cambio_categoria);
      const fechaInicio = new Date(categoria.fecha_inicio_cambio_categoria);
      const fechaHoyRango = new Date(today.getFullYear(), today.getMonth(), today. getDate());
      const fechasEnRango: boolean =
      fechaHoyRango <= fechaFin && fechaHoyRango >= fechaInicio;
      const hayNuevasCategorias: boolean =
        categoria.ids_categorias !== "" ||
        categoria.ids_categorias !== null ||
        categoria.ids_categorias !== undefined;
      
      if (fechasEnRango) {
        this.hasRequiredActions = esObligatorio;;
        return this.onAlertaSeleccionarNuevaCategoria(
          hayNuevasCategorias,
          esObligatorio,
          categoria
        );
      }
    }
  }
  private onAlertaSeleccionarNuevaCategoria(
    hayNuevasCategorias: boolean,
    esObligatorio: boolean,
    categoria: any
  ): any {
    if (!hayNuevasCategorias) {
      return;
    }
    const modal = this.modalService.open(ModalNuevaCategoriaComponent, {
      centered: true,
      backdrop: "static",
      size: "lg",
      keyboard: false,
    });
    modal.componentInstance.titulo = categoria.titulo_mensaje_permitir_cambio_categoria;
    modal.componentInstance.mensaje = categoria.mensaje_permitir_cambio_categoria;
    modal.componentInstance.esObligatorio = esObligatorio;
    modal.componentInstance.categoriaData = this.rnt.categoria_id;
    modal.result.then((res: any) => {
            
            if (res.nueva_categoria_id && res.subcategoria_id) {
              this.hasRequiredActions = false;
              this.completaForm.controls.categoria_id.setValue(
                res.nueva_categoria_id
              );
              this.completaForm.controls.desc_categoria.enable();
              this.completaForm.controls.desc_categoria.setValue(
                res.desc_nueva_categoria
              );
              this.completaForm.controls.desc_categoria.disable();
              const subcategorias: SubCategoriaEntry = {
                sub_categoria_id: res.subcategoria_id,
                descripcion: res.desc_subcategoria,
                activo: true,
                orden: 0,
                usuario_auditoria: "",
              };
              this.subCategorias = [subcategorias];
              this.completaForm.controls.sub_categoria_id.setValue(
                res.subcategoria_id
              );
              this.completaForm.controls.sub_categoria_id.disable();
            }
      });
  }
}
